import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Currency = 'TRY' | 'USD' | 'EUR';

export interface CurrencySymbols {
  TRY: '₺';
  USD: '$';
  EUR: '€';
}

export const CURRENCY_SYMBOLS: CurrencySymbols = {
  TRY: '₺',
  USD: '$',
  EUR: '€',
};

export const CURRENCY_NAMES = {
  TRY: 'Türk Lirası (₺)',
  USD: 'US Dollar ($)',
  EUR: 'Euro (€)',
};

interface CurrencyState {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
  getSymbol: () => string;
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set, get) => ({
      currency: 'TRY',
      setCurrency: (currency) => set({ currency }),
      getSymbol: () => CURRENCY_SYMBOLS[get().currency],
    }),
    {
      name: 'broiler-currency-storage',
    }
  )
);
